import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, FullBar } from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import PropTypes from "prop-types";
import { BrandElement } from "assets/js/scenes/brand/components/brandElements/BrandElement";
import { BrandFont } from "assets/js/scenes/brand/components/brandElements/BrandFont";
import { BrandUpload } from "assets/js/scenes/brand/components/brandElements/BrandUpload";
import { BrandFontGoogle } from "assets/js/scenes/brand/components/brandElements/BrandFontGoogle";
import { showResetDialog } from "assets/js/scenes/brand/utils";

const basePath = "theme.base";
let key = new Date().getTime();
export const Fonts = (props) => {
	const base = props.localBrand?.theme?.base;
	const defaultBase = props.brand?.theme?.base;
	//const advance = props.localBrand?.theme?.advance;

	function reset() {
		// TODO
		function resetConfirm() {
			//props.resetTabData(basePath", ["font"]);
			key = new Date().getTime();
		}
		showResetDialog(
			<Translate value="app-brand-modal-tab-fonts-reset" />,
			<p>
				<Translate
					value="app-brand-modal-tab-fonts-reset-desc"
					resellerName={props.resellerName}
				/>
			</p>,
			resetConfirm
		);
	}

	return (
		<div className="brandModalTabContent Fonts" key={key}>
			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-fonts-section-title-google" />
					</p>
				}
				right={
					<Button
						shapeStyle="stroke"
						colorTheme="grey"
						text={<Translate value="app-brand-modal-tab-fonts-reset" />}
						onClick={reset}
					/>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-fonts-google-title" />}
					desc={<Translate value="app-brand-fonts-google-desc" dangerousHTML />}
					rightPanel={<BrandFontGoogle />}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-fonts-section-title-custom" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-fonts-custom-title" />}
					desc={<Translate value="app-brand-fonts-custom-desc" />}
					rightPanel={<BrandUpload type="font" />}
				/>
			</div>

			<FullBar
				className="tabContentTitleRow"
				left={
					<p className="h7">
						<Translate value="app-brand-modal-tab-fonts-section-title-typography" />
					</p>
				}
			/>

			<div className="brandElementsContainer">
				<BrandElement
					title={<Translate value="app-brand-fonts-typography-primary-title" />}
					desc={<Translate value="app-brand-fonts-typography-primary-desc" />}
					rightPanel={<BrandFont />}
				/>
				<BrandElement
					title={
						<Translate value="app-brand-fonts-typography-primary-bold-title" />
					}
					desc={
						<Translate value="app-brand-fonts-typography-primary-bold-desc" />
					}
					rightPanel={<BrandFont />}
				/>

				<BrandElement
					title={
						<Translate value="app-brand-fonts-typography-secondary-title" />
					}
					desc={<Translate value="app-brand-fonts-typography-secondary-desc" />}
					rightPanel={<BrandFont />}
				/>
				<BrandElement
					title={
						<Translate value="app-brand-fonts-typography-secondary-bold-title" />
					}
					desc={
						<Translate value="app-brand-fonts-typography-secondary-bold-desc" />
					}
					rightPanel={<BrandFont />}
				/>
			</div>
		</div>
	);
};

Fonts.propTypes = {
	updateBrandLocalData: PropTypes.func,
	resellerName: PropTypes.string,
};

Fonts.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				resellerName: state.brand?.name,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(Fonts)
);
